import { render, staticRenderFns } from "./SignApp.vue?vue&type=template&id=13c450a7&scoped=true&lang=pug&"
import script from "./SignApp.vue?vue&type=script&lang=js&"
export * from "./SignApp.vue?vue&type=script&lang=js&"
import style0 from "./SignApp.vue?vue&type=style&index=0&id=13c450a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c450a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
